"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotomeasureButton = void 0;
const core_api_1 = require("@ikegps/core-api");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const photomeasure_button_style_1 = require("./photomeasure.button.style");
(0, theme_1.addStyles)(photomeasure_button_style_1.Style);
function stopPropagation(e) {
    e.stopPropagation();
}
exports.PhotomeasureButton = {
    view(tagId, collectionUUID) {
        '';
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.PHOTO_MEASURE, {
            title: index_1.T.LINK_PHOTOMEASURE,
            className: photomeasure_button_style_1.CSS.container,
            href: page_1.IkePageName.collectionMeasure,
            hrefParams: {
                d: services_1.Services.Department.current.objectId,
                t: tagId,
                collection: collectionUUID,
            },
            disabled: false,
            onclick: stopPropagation,
        });
    },
    getParams(tagId, collectionUUID) {
        return {
            d: services_1.Services.Department.current.objectId,
            t: tagId,
            collection: collectionUUID,
        };
    },
    getUrl(tagId, collectionId, collectionUUID) {
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_EDIT)) {
            const departmentId = services_1.Services.Department.current.objectId;
            return collectionUUID != null
                ? `measure?d=${departmentId}&t=${tagId}&collection=${collectionUUID}`
                : `measure?d=${departmentId}&t=${tagId}`;
        }
        return collectionId != null ? `m/${tagId}/${collectionId}` : `m/${tagId}`;
    },
};
//# sourceMappingURL=photomeasure.button.js.map